export const Container = ({ children }) => {
  return <div className=" p-12 min-h-screen">{children}</div>;
};
